(function($) {
  "use strict";

  let videoObserver = null;

  function getVideoObserver() {
    if (!videoObserver && "IntersectionObserver" in window) {
      videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const videoElement = entry.target;
          if (!document.contains(videoElement)) {
            videoObserver.unobserve(videoElement);
            return;
          }
          if (entry.isIntersecting) {
            for (let source of videoElement.children) {
              if (
                typeof source.tagName === "string" &&
                source.tagName === "SOURCE" &&
                source.dataset.src
              ) {
                source.src = source.dataset.src;
              }
            }
            videoElement.load();
            videoElement.classList.remove("lazy");
            videoObserver.unobserve(videoElement);
          }
        });
      });
    }
    return videoObserver;
  }

  function lazyloadVideo(video) {
    const videoElement = video.get(0);
    const observer = getVideoObserver();
    if (observer) {
      observer.observe(videoElement);
    }
  }

  Drupal.behaviors.lazyloadVideo = {
    attach(context) {
      $(once("lazyloadVideo", "video.lazy", context)).each(function() {
        lazyloadVideo($(this));
      });
    },
  };
})(jQuery);
